import { Component } from '@angular/core';

import { LoadingController, Popover, PopoverController } from 'ionic-angular';
import { ImageService } from '../../../../services/image.service';
import { NotificationService } from '../../../../services/texting.service';
import { AlertMessager } from '../../../../lib/alertMessager';
import { TextAdvertisement } from '../../../../model/textAdvertisement';
import { RodeoEventService } from '../../../../services/rodeoEvent.service';
import { RodeoService } from '../../../../services/rodeo.service';
import { SearchOptions } from '../../../../model/searchOptions';
import { Rodeo } from '../../../../model/rodeo';
import { SearchComponent } from '../../../../pages/search/search.component';

@Component({
    selector: 'admin-notification',
    templateUrl: 'notification.html'
})
export class NotificationSection {
    popoverActive: boolean;
    dataLoading: boolean;

    textAdvertisement: TextAdvertisement = new TextAdvertisement();
    accountId: any;
    accountName: any;

    rodeoResults: Rodeo[];

    imageFile: any;
    imageUrl: any;

    disciplines: any[] = [];
    estimatedReach: any = null;

    constructor(private notifcationService: NotificationService, private alertMessager: AlertMessager, 
        private rodeoEventService: RodeoEventService, private loadingControl: LoadingController, 
        private popoverController: PopoverController, private imageService: ImageService, private rodeoService: RodeoService) { 
        this.rodeoEventService.getEventTypes()
        .then(data => {
            this.disciplines = data as string[];
        });

        this.rodeoService.searchRodeos(new SearchOptions())
            .then(data => {
                this.rodeoResults = [];
                Object.assign(this.rodeoResults, data);
            }, error => {
                console.log(error);
            });
    }

    openUserSearch(searchEvent, teammateSearch) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: "User Search",
                userSearch: true,
                addNew: false
            }
        }, { cssClass: 'app-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data != null) {
                if (data.id > 0) {
                    this.accountName = data.firstName + ' ' + data.lastName;
                    this.accountId = data.id;
                }
            }
        })
    }

    async sendPushes() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        if (!this.estimatedReach)
            await this.getReach();

        let loader = this.loadingControl.create({
            content: 'Sending out ' + this.estimatedReach + ' pushes...',
        });

        if (this.imageUrl) {
            this.textAdvertisement.imgUrls = [];
            this.textAdvertisement.imgUrls.push(this.imageUrl);
        }

        loader.present();
        this.notifcationService.sendPushes(this.textAdvertisement, this.accountId)
            .then((data) => {
                this.popoverActive = false;
                loader.dismiss();
                this.alertMessager.showConfirmation("Success", data + " Pushes Successfully Sent");
            }, error => {
                console.log("error: ", error);
                this.popoverActive = false;
                loader.dismiss();
                this.alertMessager.showError("Push Send Error", error);
            })
    }

    async getReach() {
        if (this.dataLoading)
            return;

        this.dataLoading = true;

        let loader = this.loadingControl.create({
            content: 'Updating estimated reach...',
        });
        loader.present();
        await this.notifcationService.getPushReach(this.textAdvertisement)
            .then((data) => {
                this.dataLoading = false;
                loader.dismiss();
                this.estimatedReach = data;
            }, error => {
                this.dataLoading = false;
                loader.dismiss();
            })
    }

    logoFileChangeListener($event): void {
        this.imageFile = $event.target.files[0];
        this.uploadLogoFile();
    }

    uploadLogoFile() {
        if (this.popoverActive)
            return;

        let loader = this.loadingControl.create({
            content: 'Uploading Flier...',
        });

        loader.present();
        this.popoverActive = true;
        let fileName = Math.floor((Math.random() * 1000) + 1) + "_flier_" + this.imageFile.name;

        this.imageService.uploadImage(this.imageFile, fileName, false)
            .then(data => {
                loader.dismiss();
                this.popoverActive = false;
                this.imageUrl = "https://nextgenrodeomedia.blob.core.windows.net/images/" + fileName;
            }, error => {
                loader.dismiss();
                this.popoverActive = false;
                this.alertMessager.showError("Logo Upload Error", error);
            });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/admin/notification/notification.ts